import BaseSearchDropdown from './BaseSearchDropdown';

export default class ImagingDropdown extends BaseSearchDropdown {
    constructor(props) {
        super(props);
        this.formatter = imaging => `${imaging.name} ${imaging.cpt}`;
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/ImagingDropdown.jsx